import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes, instanceOf} from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import BSContentService from '../../services/BSContentService';
import BSAuthService from '../../services/BSAuthService';
import CookieStorageService from '../../services/CookieStorageService';
import ChromeExtensionService from '../../services/ChromeExtensionService';
import * as session_handlers from '../../actions/session_handler';
import { BSAUTH_COOKIE, LOGIN_TOKEN_TYPE_BSAUTH } from '../../constants/cookie_constants';
import './LoggedInContainer.css';

const getInitialState = () => ({
    errorMsg: ''
});
const WELCOME_BACK_COMIC_ID = 20054902;
const LOGGED_IN_TITLE = 'You\'re Logged In!';
const LOGGED_IN_TEXT_AVATAR = 'You can now use Bitmoji in Chrome, Gmail, and Slack.';
const LOGGED_IN_TEXT_NO_AVATAR = 'The next step is to create your Avatar using the Bitmoji mobile app.';
const LOGOUT_TEXT = 'Log Out';

class LoggedInContainer extends Component {
    constructor (props) {
        super(props);
        this.logout = this.logout.bind(this);
        this.state = getInitialState();
    }

    logout() {
        const { session, cookies } = this.props;

        if (session.loginTokenType === LOGIN_TOKEN_TYPE_BSAUTH ) {
            const bsAuthToken = CookieStorageService.get(BSAUTH_COOKIE, cookies);
            BSAuthService.logoutUser(bsAuthToken);
        } else {
            ChromeExtensionService.sendMessage({signal: 'BitmojiWebAppUserLoggedOut'}, null);
        }

        CookieStorageService.clearAllCookies(cookies);
        this.props.updateLoginSession(false, null);
    }

    render() {
        const { avatarId } = this.props;

        const templateUrl = BSContentService.getTransparentAvatarForComicId(
            WELCOME_BACK_COMIC_ID, avatarId
        );

        return (
            <div className="logged-in-container" id="logged-in-container">
                <div className="left-col">
                    <div className="logged-in-title">
                        <p>{LOGGED_IN_TITLE}</p>
                    </div>
                    <div className="logged-in-text">
                        <p>{ avatarId ? LOGGED_IN_TEXT_AVATAR : LOGGED_IN_TEXT_NO_AVATAR}</p>
                    </div>
                    <button className="logout-button" name="logout-button" onClick={this.logout}>
                        <span className="label-bold">{LOGOUT_TEXT}</span>
                    </button>
                    <div className="revoke-cookies">
                        <a onClick={this.logout}>
                            Revoke Cookies
                        </a>
                    </div>
                </div>
                <div className="right-col">
                    { avatarId ?
                        <div className="welcomeback-bitmoji">
                            <img src={templateUrl} alt={templateUrl}/>
                        </div> : <div className="graphic-no-avatar" />
                    }
                </div>
            </div>
        );
    }
}

LoggedInContainer.propTypes = {
    avatarId: PropTypes.string.isRequired,
    updateLoginSession: PropTypes.func.isRequired,
    session: PropTypes.object.isRequired,
    cookies: instanceOf(Cookies).isRequired
};

export default connect(state => ({
    session: state.sessionReducer
}), session_handlers)(withCookies(LoggedInContainer));



// WEBPACK FOOTER //
// ./src/components/congrats_view/LoggedInContainer.js